import { defineSlotRecipe } from '@chakra-ui/react';
import { tooltipAnatomy } from '@chakra-ui/react/anatomy';

/** KDS Tooltip — Kintsugi Design System node 260:4375. */
export const tooltipSlotRecipe = defineSlotRecipe({
  slots: tooltipAnatomy.keys(),
  base: {
    content: {
      '--tooltip-bg': 'colors.brand.600',
      bg: 'var(--tooltip-bg)',
      color: 'neutral.0',
      textStyle: 'default.regular',
      px: '2',
      py: '2',
      borderRadius: 'md',
      boxShadow: 'menu',
      whiteSpace: 'pre-wrap',
      textAlign: 'left',
    },
    arrow: {
      '--arrow-background': 'var(--tooltip-bg)',
    },
    arrowTip: {
      borderColor: 'var(--tooltip-bg)',
    },
  },
});
